// store
import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import SessionSlice from './SessionSlice';
import CommonSlice from './CommonSlice';
import OrganizationSlice from './OrganizationSlice';
import NotificationSlice from './NotificationSlice';
import GlobalFilterSlice from './GlobalFilterSlice';
import DropDownSlice from './DropDownSlice';
import RxntSlice from './RxntSlice';
// Multi-profile patient architecture (clone / related profiles / archive).
import EmployeeCloneSlice from './EmployeeCloneSlice';


const persistConfig = {
  key: 'myPersistedSlice',
  storage,
};
const persistedReducer = persistReducer(persistConfig, SessionSlice);
const globalPersistedReducer = persistReducer(persistConfig, GlobalFilterSlice);

//Slice : reducer
const store = configureStore({
  reducer: {
    session: persistedReducer,
    common:CommonSlice,
    organization:OrganizationSlice,
    notification:NotificationSlice,
    globalFilter: GlobalFilterSlice,
    dropDown:DropDownSlice,
    rxnt: RxntSlice,
    // Multi-profile patient architecture (clone / related profiles / archive).
    // NOT persisted — admin-tooling data should always be fetched fresh.
    employeeClone: EmployeeCloneSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      // serializableCheck: {
      //   ignoredActions: ['persist/PERSIST'],
      // },
    }),
});

const persistor = persistStore(store);

export { store, persistor };